interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1).filter((p) => {
    if (total <= 7) return true;
    return p === 1 || p === total || Math.abs(p - current) <= 1;
  });

  const items: (number | string)[] = [];
  pages.forEach((p, i) => {
    if (i > 0 && p - (pages[i - 1] as number) > 1) items.push(`gap-${p}`);
    items.push(p);
  });

  return (
    <div className="flex items-center justify-center flex-wrap gap-2 mt-8">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex items-center gap-1 px-3 py-2 rounded-md text-sm bg-background-100 border border-background-200 text-foreground-700 enabled:hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {items.map((item) => {
        if (typeof item === "string") {
          return (
            <span key={item} className="px-2 text-foreground-500 text-sm">
              …
            </span>
          );
        }
        const active = item === current;
        return (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
              active
                ? "bg-accent-500 text-background-50"
                : "bg-background-100 border border-background-200 text-foreground-700 hover:text-accent-500"
            }`}
          >
            {item}
          </button>
        );
      })}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex items-center gap-1 px-3 py-2 rounded-md text-sm bg-background-100 border border-background-200 text-foreground-700 enabled:hover:text-accent-500 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}